import { Component, OnInit } from '@angular/core';
import { StepComponent } from '../step.component';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-slider-step',
  templateUrl: './slider-step.component.html',
  styleUrls: ['./slider-step.component.scss']
})
export class SliderStepComponent extends StepComponent implements OnInit {
  control: UntypedFormControl;
  sliderValue: number;
  sliderValues: Array<number>;
  sliderLabels: Array<string>;
  sliderDisplay: string;
  enterHomeValue: number;
  enterStringFieldValue: string;

  ngOnInit() {
  }

  slide(e) {
    this.sliderValue = e.target.value;
    this.sliderDisplay = this.sliderLabels[e.target.value];
  }

  submit(value: any): void {
    // If no slide, use default    
    if (typeof value === 'undefined') {
      value = this.sliderValues[this.sliderValue];
    }else if(this.enterHomeValue){ 
      //probably we need to use this.enterFieldValue
      //not sure what max value we can put to the DB
      value = (this.enterHomeValue < 3000000) ? this.enterHomeValue : 3000000 ;      
    }else {
      value = this.sliderValues[value];
    }

    this.control.setValue(value);

    // Most uses for this type of step will need to update desired loan amount and LTV
    this.setDesiredLoanAmount();
    this.setLTV();

    this.analyticsService.trackQuestionAnswered();

    // Check if redirecting after above numbers are figured
    // if (this.redirectTables(value)) {
    //   this.fruHttpService.redirectRateTables(this.form);
    //   return;
    // }

    this.nextStep();
  }
}
